import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

const AddLabelClaimDialog = ({
  open,
  onClose,
  newLabelClaim,
  setNewLabelClaim,
  handleAddNewLabelClaim,
  handleFileChange,
}) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewLabelClaim({
      ...newLabelClaim,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFileInputChange = (e) => {
    handleFileChange(e);
    e.target.value = null; // Reset file input
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Label Claim</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          name="grade"
          label="Grade"
          type="text"
          fullWidth
          value={newLabelClaim.grade || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="label_claim"
          label="Label Claim"
          type="text"
          fullWidth
          required
          value={newLabelClaim.label_claim || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="condition"
          label="Condition"
          type="text"
          fullWidth
          required
          value={newLabelClaim.condition || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="ingredients"
          label="Ingredients"
          type="text"
          fullWidth
          value={newLabelClaim.ingredients || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="description"
          label="Description"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={newLabelClaim.description || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="health_claims"
          label="Health Claims"
          type="text"
          fullWidth
          required
          value={newLabelClaim.health_claims || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="dosage"
          label="Dosage"
          type="text"
          fullWidth
          value={newLabelClaim.dosage || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="format"
          label="Format"
          type="text"
          fullWidth
          value={newLabelClaim.format || ""}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="amount"
          label="Amount"
          type="number"
          fullWidth
          value={newLabelClaim.amount || ""}
          onChange={handleChange}
          inputProps={{ step: "0.01" }}
        />
        <TextField
          margin="dense"
          name="booking_fee"
          label="Booking Fee"
          type="number"
          fullWidth
          value={newLabelClaim.booking_fee || ""}
          onChange={handleChange}
          inputProps={{ step: "0.01" }}
        />
        <FormControlLabel
          control={
            <Checkbox
              name="prototype"
              checked={newLabelClaim.prototype || false}
              onChange={handleChange}
            />
          }
          label="Prototype"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="clinical_trials"
              checked={newLabelClaim.clinical_trials || false}
              onChange={handleChange}
            />
          }
          label="Clinical Trials"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="regulatory"
              checked={newLabelClaim.regulatory || false}
              onChange={handleChange}
            />
          }
          label="Regulatory"
        />
        <input
          type="file"
          onChange={handleFileInputChange}
          style={{ marginTop: "16px" }}
          accept=".xlsx,.pdf"
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleAddNewLabelClaim} color="primary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddLabelClaimDialog;